import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Home, LayoutGrid, Plus, MessageCircle, User } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";
import { useRequestModal } from "../context/RequestModalContext";
import { whatsAppSimple } from "../lib/api";

export const MobileNav = () => {
  const { t } = useI18n();
  const { openRequest } = useRequestModal();
  const navigate = useNavigate();

  const go = (hash) => {
    if (window.location.pathname !== "/") { navigate("/"); setTimeout(() => { window.location.hash = hash; }, 60); }
    else window.location.hash = hash;
  };

  const item = "flex flex-col items-center gap-1 text-[0.6rem] tracking-wider uppercase text-vm-muted";

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-vm-bg/90 backdrop-blur-xl border-t border-vm-border" data-testid="mobile-nav">
      <div className="grid grid-cols-5 items-end h-16 px-2">
        <button onClick={() => go("#top")} className={item} data-testid="mobilenav-home">
          <Home strokeWidth={1.25} size={20} /> {t("nav.home")}
        </button>
        <button onClick={() => go("#aviation")} className={item} data-testid="mobilenav-services">
          <LayoutGrid strokeWidth={1.25} size={20} /> {t("nav.services")}
        </button>
        <button onClick={() => openRequest("other")} className="flex flex-col items-center -mt-6" data-testid="mobilenav-request">
          <span className="w-14 h-14 rounded-full bg-vm-accent text-vm-bg flex items-center justify-center shadow-lg">
            <Plus strokeWidth={1.5} size={26} />
          </span>
          <span className="text-[0.6rem] tracking-wider uppercase text-vm-accent mt-1">{t("nav.request")}</span>
        </button>
        <a href={whatsAppSimple()} target="_blank" rel="noopener noreferrer" className={item} data-testid="mobilenav-concierge">
          <MessageCircle strokeWidth={1.25} size={20} /> {t("nav.concierge")}
        </a>
        <Link to="/admin" className={item} data-testid="mobilenav-account">
          <User strokeWidth={1.25} size={20} /> {t("nav.account")}
        </Link>
      </div>
    </nav>
  );
};
